export default __webpack_public_path__ + "static/media/slidermain.a3e7c212.jpg";